import { render, staticRenderFns } from "./editBlockLeavePolicy.vue?vue&type=template&id=654db2f2&"
import script from "./editBlockLeavePolicy.vue?vue&type=script&lang=js&"
export * from "./editBlockLeavePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654db2f2')) {
      api.createRecord('654db2f2', component.options)
    } else {
      api.reload('654db2f2', component.options)
    }
    module.hot.accept("./editBlockLeavePolicy.vue?vue&type=template&id=654db2f2&", function () {
      api.rerender('654db2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/BlockLeave/BlockLeavePolicy/editBlockLeavePolicy.vue"
export default component.exports